import { PickerDay, type PickerDayProps } from '@mui/x-date-pickers/PickerDay';
import { FC } from 'react';

import { type DateRange, resolveDayState } from './range-selection';

export interface RangeDayProps extends Omit<PickerDayProps, 'onDaySelect'> {
  range: DateRange;
  hovered: Date | null;
  onHover: (_day: Date | null) => void;
  onDaySelect?: (_day: Date) => void;
}

export const RangeDay: FC<RangeDayProps> = ({
  range,
  hovered,
  onHover,
  onDaySelect,
  ...dayProps
}) => {
  const state = resolveDayState(dayProps.day, range, hovered);

  return (
    <PickerDay
      {...dayProps}
      onDaySelect={onDaySelect ?? (() => {})}
      {...(state && { 'data-range-state': state })}
      onMouseEnter={(_event, day) => onHover(day)}
      onMouseLeave={() => onHover(null)}
    />
  );
};
